// Dependencies
import styled from 'styled-components';

const MeetTheMatchmakersStyles = styled.section`
  text-align: center;

  .header {
    margin-bottom: 4rem;
  }

  .text {
    margin: 0 auto;
    max-width: 55rem;
  }

  .wrapper {
    margin: 0 auto 3rem;
  }

  .matchmaker {
    background-color: var(--color-sand);
    text-align: left;
    cursor: pointer;
    height: 100%;

    .name,
    .job-title {
      margin: 0;
      text-transform: none;
    }

    .name {
      font-weight: var(--font-weight-medium);
      transition: color 0.4s;
      transition-delay: 0.1s;
    }

    .job-title {
      font-weight: var(--font-weight-regular);
      opacity: 0.6;
    }

    .top {
      position: relative;

      .headshot {
        width: 100%;
        height: 12rem;

        img {
          object-position: top;
        }
      }

      .overlay {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        align-items: flex-end;
        flex-direction: row;
        width: 100%;
        height: 100%;
        padding: 2rem;
        opacity: 0;
        pointer-events: none;
        color: var(--color-white);
        background-color: rgba(160, 152, 143, 0.5);
        transition: opacity 0.4s;
      }
    }

    .bottom {
      padding: 1.5rem;
      text-align: left;

      .btn {
        margin: 1rem 0 0;
      }

      .btn:hover,
      .btn:focus {
        color: var(--color-bark);
      }
    }
  }

  @media (min-width: 500px) {
    .matchmaker .top .headshot {
      height: 14rem;
    }
  }

  @media (min-width: 768px) {
    .matchmaker .top .headshot {
      height: 18rem;
    }
  }

  @media (min-width: 1400px) {
    .matchmaker .top .headshot {
      height: 20rem;
    }
  }
`;

export default MeetTheMatchmakersStyles;
